module.exports = {
	"articleTitle1": "Mack Attack: A look back on Rachael Mack's career",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Phyllis Ocker Field",
	"articleLink2": "https://www.michigandaily.com/sports/field-hockey-dominant-home-win-against-central-michigan",
	"articleSnippet1": "Nov 20, 2013 ... In the first chapter of senior forward Rachael Mack's Michigan legacy she stood \non Phyllis Ocker Field for the first home game of her Michigan ...",
	"articleSnippet2": "Sep 7, 2014 ... Coming home to the newly renovated Phyllis Ocker Field proved to be well worth \nthe wait. After delayed construction left the Michigan field ...",
	"totalMisc": 0,
	"articleTitle2": "Field hockey dominant in home win against Central Michigan",
	"address": "1202 S. State St. Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160914/rom.FHK_.vsVillanova.9.10.16.0091.jpg?itok=WRHXuQHn",
			"author": "Ryan McLaughlin",
			"caption": "The Michigan field hockey team has had surprising success in replacing nearly half its scoring from a year ago and is off to a 4-1 start to the season."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/150921/gbh.FHK_.9.20.15.vsKentState.482.jpg?itok=RD44r--9",
			"author": "Grant Hardy",
			"caption": "Maggie Bettez stepped up when Mackenzie Ellis went down with an injury."
		}
	],
	"position": {
		"lat": 42.266523,
		"lng": -83.742031
	},
	"tips": [],
	"articleLink1": "https://www.michigandaily.com/sports/look-back-rachael-mack",
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/phyllisockerfield.json
// module id = 945
// module chunks = 0